// Standalone layout component - No sidebar, no header, just content
// Used for checkout pages and other standalone views
import { Outlet } from 'react-router-dom';

export const StandaloneLayout: React.FC = () => {
  return (
    <div className="min-h-screen w-full">
      <Outlet />
    </div>
  );
};




























































